import { createQueryClient } from '@noor/config';
import { getApiErrorMessage, isApiError } from '@noor/api';
import { toast } from '@noor/lib';
import { isDeliveryForbiddenError } from '@/shared/lib/delivery-errors';
import { i18n } from './i18n';

export function createMerchantQueryClient() {
  let lastErrorToast: { key: string; at: number } | undefined;
  const showApiErrorToast = (error: unknown) => {
    const deliveryForbidden = isDeliveryForbiddenError(error);
    const message = deliveryForbidden
      ? i18n.t('errors:auth.forbiddenAction')
      : getApiErrorMessage(error, i18n.t('errors:unknown'));
    const key = deliveryForbidden
      ? `delivery:403:${message}`
      : isApiError(error)
        ? `${error.status}:${error.code}:${message}`
        : message;
    const now = Date.now();
    if (lastErrorToast?.key === key && now - lastErrorToast.at < 1000) return;
    lastErrorToast = { key, at: now };
    toast.error(message);
  };

  return createQueryClient({
    onMutationError: showApiErrorToast,
    // Permission failures must be visible even for silent price previews or
    // mutations whose ordinary errors are handled locally.
    onSuppressedMutationError: (error) => {
      if (isDeliveryForbiddenError(error)) showApiErrorToast(error);
    },
    onQueryError: (error) => {
      if (isApiError(error) && error.status === 403) showApiErrorToast(error);
    },
  });
}
